var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_480)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6284 0L21.9796 31.9896H15.8709L18.3634 17.9515L12.0415 23.1405L10.4713 31.9896H4.36133L10.0102 0H16.1175L13.0705 17.3437L19.3738 12.196L21.5197 0H27.6284Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.9896,
    height: 31.9896,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.9896,
    height: 31.9896,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity);
export default __webpack_public_path__ + "static/media/Integrity.2ab39aa33ac5766d80e740234505c6df.svg";
export { ForwardRef as ReactComponent };